import { default as Notice } from './Notice';

export default Notice;
export { default as NoticeSmart } from './NoticeSmart';
